import { shopPrefix } from '../../config';
import { http } from '../axios';

interface ProductAvailabilityResponse {
    available: boolean;
    nextAvailableDate: string | null;
}

export const fetchNextAvailableDates = (productId: string) => {
    return http
        .get<ProductAvailabilityResponse>(`${shopPrefix}/v2/products/:productId/availability`, {
            pathParams: { productId }
        })
        .then(response => response.data);
};
